import React from 'react';
import classNames from 'classnames';
import Dismissable from './dismissable';

/**
 * @prop {any} children
 * @prop {bool} autoPosition
 * @prop {any} dismissCallback
 * @prop {any} styleName
 * @prop {string} top
 */

class Popover extends React.Component {
  static defaultProps = {
    position: 'left',
    autoPosition: false,
    dismissable: true,
  };

  componentDidMount() {
    if (this.props.autoPosition) {
      this.timeoutId = window.setTimeout(this.positionPopover.bind(this), 0);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeoutId);
  }

  positionPopover() {
    if (this.arrow && this.popover) {
      const { height, top } = this.popover.container.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (height > windowHeight - top - 10) {
        this.popover.container.style.top = `${-height - 10}px`;
        this.arrow.style.bottom = `${0}px`;
        this.arrow.style.top = 'initial';
        this.arrow.style.border = '0';
        this.arrow.style.borderBottom = '1px solid rgba(222, 221, 221, .7)';
        this.arrow.style.borderRight = '1px solid rgba(222, 221, 221, .7)';
      }
    }
  }

  render() {
    const { dismissable, dismissCallback } = this.props;
    const className = classNames({
      NewPopover: !this.props.customClass,
      'NewPopover--right': this.props.position === 'right',
      [this.props.styleName]: !!this.props.styleName,
    });

    const Wrapper = dismissable ? Dismissable : 'div';

    return (
      <Wrapper
        className={className}
        ref={n => {
          this.popover = n;
        }}
        {...(dismissable && { dismissCallback })}
      >
        <div className="NewPopover-content">{this.props.children}</div>
        <div
          className="NewPopover-arrow"
          ref={n => {
            this.arrow = n;
          }}
        />
      </Wrapper>
    );
  }
}

export default Popover;
